var NodeModel = /** @class */ (function () {
    function NodeModel() {
    }
    return NodeModel;
}());
export { NodeModel };
var NodeOptionsObject = /** @class */ (function () {
    function NodeOptionsObject(data) {
        if (data === void 0) { data = undefined; }
        this.enablePan = true;
        this.objectName = '';
        this.showAddChild = true;
        this.title = '';
        this.zoom = false;
        this.workflowType = '';
        this.metaData = undefined;
        this.status = '';
        this.isDraftMode = true;
        this.autoSave = true;
        this.workflowId = 0;
        this.viewMode = 'form';
        this.tasksStatus = {};
        this.audit = {};
        if (data) {
            for (var key in data) {
                if (this.hasOwnProperty(key)) {
                    this[key] = data[key];
                }
            }
        }
    }
    return NodeOptionsObject;
}());
export { NodeOptionsObject };
